export const white = "#FFFFFF";
export const offBlack = "#212529";
export const black = "#000000";
export const brown = "#a87a53";
export const boxShadow = "0px 3px 25px 0px rgba(0, 0, 0, 0.15)";
export const orange = "#FF8730";
export const blue = "#66C3FE";
